<template>
  <div>
    <group-emails-sent-report-table
      ref="table"
      :url="indexUrl"
      :filter-list="filters"
      :download-url="downloadUrl"
      :can-download="canDownload"
    ></group-emails-sent-report-table>
  </div>
</template>

<script>
import GroupEmailsSentReportTable from '../../components/reports/group-emails-sent/table';
import eventBus from '../../event-bus';

export default {
  components: {
    GroupEmailsSentReportTable,
  },

  props: {
    indexUrl: String,
    filters: Array,
    downloadUrl: String,
    canDownload: Boolean,
  },

  methods: {
    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.table.refresh();
    },
  },

  created() {
    eventBus.$on('refresh-group-emails-sent-report-table', this.refresh);
  },

  beforeDestroy() {
    eventBus.$off('refresh-group-emails-sent-report-table', this.refresh);
  }
}
</script>
